import { FullReleaseWaitlistForm } from '../../waitlist/FullReleaseWaitlistForm';
import './landingRef.css';

type Props = {
  h2: string;
  sub: string;
  badge: string;
  inviteLeadIn: string;
  inviteLinkLabel: string;
  inviteHref: string;
};

export function WaitlistPremiumSection({
  h2,
  sub,
  badge,
  inviteLeadIn,
  inviteLinkLabel,
  inviteHref,
}: Props) {
  const introParagraphs = sub.split('\n\n').filter(Boolean);

  return (
    <section className="ml-waitlistSection" aria-labelledby="waitlist-heading">
      <div className="page-wrap">
        <div className="ml-waitlistPremium">
          <div className="ml-waitlistPremium__glow" aria-hidden />
          <span className="ml-waitlistPremium__badge">{badge}</span>
          <h2
            id="waitlist-heading"
            className="ml-h2 ml-sect__title ml-sect__title--waitlist ml-heading-sans ml-text-heading">
            {h2}
          </h2>
          <div className="ml-waitlistPremium__intro">
            {introParagraphs.map((para) => (
              <p key={para} className="ml-waitlistPremium__introLine ml-text-body-secondary">
                {para}
              </p>
            ))}
          </div>
          <FullReleaseWaitlistForm />
          <p className="ml-waitlistPremium__invite">
            <span className="ml-waitlistPremium__inviteLead">{inviteLeadIn}</span>{' '}
            <a className="ml-waitlistPremium__inviteLink" href={inviteHref}>
              {inviteLinkLabel}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
